import React, { useContext, FC } from "react";
import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Dimmer, Loader } from "semantic-ui-react";

import { RootStoreContext } from "../stores/rootStore";
import NavBar from "../../features/nav/NavBar";

interface ProtectedRoutesProps {
  children: React.ReactNode;
  expectedRole?: string;
};

const ProtectedRoutes: FC<ProtectedRoutesProps> = ({ children, expectedRole }) => {
  const rootStore = useContext(RootStoreContext);
  const { isLoggedIn, relogUsers, user } = rootStore.userStore;

  if (!isLoggedIn) {
    relogUsers()
    return (
      <Dimmer active>
        <Loader content="Loading..." size="massive" />
      </Dimmer>
    );
  }

  if (expectedRole && user?.role !== expectedRole) {
    return <Navigate to="/home/Client/DashboardClient" replace />;
  }

  return (
    <>
      <NavBar />
      {children}
    </>
  );
};

export default observer(ProtectedRoutes);
